<template>
  <div class="helpCenter">
    <div class="helpList_con">
      <h1>常见问题：</h1>
      <el-collapse v-model="activeNames" class="helpList">
        <el-collapse-item v-for="(qa, index) in qaList" :key="index" :title="qa.question" :name="index">
          <div>{{ qa.answer }}</div>
        </el-collapse-item>
      </el-collapse>
      <h4>更多问题，可拨打24小时热线电话:400-6399580</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "helpCenter",
  data() {
    return {
      activeNames: [],
      qaList: [
        {
          question: '1、电子保函是什么？',
          answer: '电子保函是近年来国家推出的利好政策，可以替代缴纳保证金。您购买电子保函只需要支付保费就可以继续投标了。'
        },
        {
          question: '2、购买保函是否有时间限制？周末和晚上能不能买？9点开标，8点购买还来得及吗？',
          answer: '没有时间限制，周末和晚上都可以购买。9点开标，8点购买还来得及，但不建议8:30后购买。'
        },
        {
          question: '3、金融机构是否有保额限制？会不会购买到一定额度就不能购买。',
          answer: '没有额度限制，都可以购买。'
        },
        {
          question: '4、待支付的订单是否可以取消重新下单？或者同一个标段购买成功后是否可以退保重新购买？',
          answer: '待支付的订单可以取消，再重新下单；同一个标段购买成功又退保后可以重新购买。'
        },
        {
          question: '5、支付页面的联行号是什么，转账时是否需要填写？',
          answer: '联行号是银行机构代码，转账时不用填写。'
        },
        {
          question: '6、附言的4-6位数代码转账时在哪里填写？',
          answer: '由于不同银行页面不同，用途/附言/摘要处皆可填写，不要附带其他文字。'
        },
        {
          question: '7、为什么我付款成功后订单任然显示待支付？保单/函也还是显示申请中？',
          answer: '线下打款成功后，需等待5-10分钟后刷新页面，再次查看支付状态和下载保单/保函。'
        },
        {
          question: '8、发票在哪里申请？',
          answer: '需要回到鼎函平台页面，在下载保函旁边就有申请发票的入口。（和田除外）'
        },
        {
          question: '9、为什么付款已经成功无法申请发票？',
          answer: '发票须在开标后才可申请。（无须开标的订单，可在支付成功的第二天即可申请）'
        },
        {
          question: '10、打款方和开票方抬头不一致？财务无法报销',
          answer: '方德保险代理与出函机构是合作关系，方德保险代理可以代收保费，但实际出函的是保司，我可以为您提供双方合作协议首尾页证明合作关系及情况说明'
        },
        {
          question: '11、发票申请成功需要多久收到？',
          answer: '电子发票一般1-2个工作日，纸质发票一般3-5个工作日。'
        },
      ]
    };
  }
};
</script>

<style scoped >
.helpCenter{
  width: 1200px;
  margin: auto;
}
.helpList_con{
  width: 1040px;
  margin: 40px auto;
  padding: 30px 50px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  height: auto;
}
.helpList_con h1{
  font-size: 22px;
  color: #000;
  font-weight: normal;
  margin-bottom: 20px;
  line-height: 1em;
}
.helpList_con h4{
  font-size: 20px;
  color: #666;
  font-weight: normal;
  margin-top: 20px;
  text-align: center;
  line-height: 2em;
}
.helpList{
  width: 100%;
  border: none;
}
.helpList .el-collapse{
  border: none;
}
.helpList .el-collapse-item {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 5px;
}
/deep/.helpList .el-collapse-item__header{
  margin: 0;
  font-size: 16px;
  line-height: 1.6em;
  color: #000;
  font-weight: normal;
}
/deep/.helpList .el-collapse-item__content {
  margin: 5px 0 0 18px;
  font-size: 16px;
  line-height: 1.6em;
  color: #666;
}
</style>
